// extracted by mini-css-extract-plugin
module.exports = {"disclaimer":"role-detail_disclaimer__1x8cA"};